import { useState } from "react";

import { CountUp } from "~/ui/base/CountUp.tsx";

/** 이 값 이상이면 좁은 폭(3열 그리드)에서 넘치지 않도록 축약 표기(1.9M, 199만 등) */
const COMPACT_THRESHOLD = 10_000;

const compactFormatter = new Intl.NumberFormat(undefined, {
  maximumFractionDigits: 1,
  notation: "compact",
});

export const Stat = ({
  label,
  value,
}: {
  label: string;
  value: null | number | undefined;
}) => {
  const [hasValueOnFirstRender] = useState(typeof value === "number");
  const isLarge = typeof value === "number" && value >= COMPACT_THRESHOLD;
  return (
    <div className="flex min-w-0 flex-col items-center text-center">
      <p
        className="max-w-full truncate text-xl font-extrabold"
        title={isLarge ? value.toLocaleString() : undefined}
      >
        {isLarge && compactFormatter.format(value)}
        {!isLarge && hasValueOnFirstRender && value?.toLocaleString()}
        {!isLarge && !hasValueOnFirstRender && (
          <CountUp duration={1500} height={28} value={value ?? null} />
        )}
      </p>
      <p className="max-w-full text-sm leading-tight">{label}</p>
    </div>
  );
};
